import { orderBy } from "lodash";
import { PAID_STATUSES } from "constants/chats";

const sortByLastMessage = (a) => a.lastMessage.createdAtJSDate;
const sortByLastContactMessage = (a) => a.lastContactMessageAtJSDate;
const sortByLastConsultantMessage = (a) => a.lastUserMessageAtJSDate;
const sortByClientName = (a) =>
  a.contact.firstName && a.contact.firstName.trim().toLowerCase();
const sortByPaidStatus = (a) => PAID_STATUSES[a.contact.transactionsLevel];

const sorts = {
  default: (items) => orderBy(items, (a) => a, "desc"),
  "last message": (items) => orderBy(items, sortByLastMessage, "desc"),
  "last client message": (items) =>
    orderBy(items, sortByLastContactMessage, "desc"),
  "last consultant message": (items) =>
    orderBy(items, sortByLastConsultantMessage, "desc"),
  "client name": (items) => orderBy(items, sortByClientName, "asc"),
  "paid status": (items) => orderBy(items, sortByPaidStatus, "desc"),
};

export const sortChats = (sort) => (chats) => sorts[sort](chats);

export const filterByTag = (tag) => (chats) => {
  if (!tag) return chats;
  return chats.filter((chat) => chat.tag?.tag === tag);
};

export const filterByNameOrId = (string) => (chats) => {
  if (!string) return chats;
  return chats.filter((chat) => {
    return new RegExp(string, "i").test(
      `${chat.contact.firstName}${chat.contact.id}`
    );
  });
};
